module.exports = __webpack_public_path__ + "img/select_arrow.bd9f5f06.svg";